export default __webpack_public_path__ + "static/media/second-layer-img-2.48fd8817.jpg";